var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beefCont"},[_c('img',{staticClass:"bg",attrs:{"src":require("../assets/imgs/101/bg.jpg"),"alt":""}}),_c('Qrcode',{attrs:{"pic":101,"bottom":'1.7rem'}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phoneCommon"},[_vm._v(" 咨询电话："),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"tel:028-87705569"}},[_vm._v("028-87705569")])])
}]

export { render, staticRenderFns }